import React, { Component } from 'react';
import axios from 'axios';
import { config } from '../../Constants';
import global from '../global';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { store } from 'react-notifications-component';
import ReactNotification from 'react-notifications-component';
import { Link } from 'react-router-dom';
import '../../Asset/Css/main_dash.css';
import { Row, Col } from 'reactstrap';
import NexdmsmImg from '../../Asset/Images/nexdigm-logo-sm.png';
import EasyDebenturesLogo from '../../Asset/Images/easy-dividend-logo.png';
import mainBG from '../../Asset/Images/easy-dividend-bg.png';
import nonResidentUser from '../../Asset/Images/non-resident-user.svg';
import ResidentUser from '../../Asset/Images/resident-user.svg';
import DebenturesHubLogo from '../../Asset/Images/Debentures-Hub-logo.svg';
import $ from 'jquery';

export class HomePage extends Component {

    constructor(props) {
        super(props);
        this.state = {           
            showCookieModal: false,
     
            RemitterLogo: 'client-logo.png',
            RemitterStyle: '80%',
            divLogin: true,
            loading: false,
            URL: config.url.Web_URL,
            IPaddress: ""
        };

        this.initialState = this.state;
        localStorage.clear(); //for localStorage
        sessionStorage.clear(); //for sessionStorage
        this.getIP();
    }

    getIP() {
        $.getJSON("https://api.ipify.org?format=json",
            function (data) {
                // Displayin IP address on screen
                console.log(data.ip);
                axios.get(global.UserManagement.SetClientIpAPI + "?ipAddr=" + data.ip).then(() => { });
            });
    }

    handleLogin = (e) => {
        window.location.href = config.url.Web_URL + '/SignIn';
    };
    
  render () {
    return (
        <div>
            <ReactNotification />

            <div class="limiter">
                <div class="container-login100" style={{ backgroundImage: 'url("' + mainBG + '")' }}>
                    <div className="content-page">
                        <div class="wrap-login100 m-t-10"> 

                            <div className="DebenturesHubLogo">
                                <img src={DebenturesHubLogo} alt="Logo"  className="logo-img" />
                            {/*    <div class="easyDebentureLogo">Debenture's Hub</div>*/}
                            </div>                            
                        <div class="login100-form">
                            <span class="login100-form-sub-title p-b-20">
                                    Welcome to Debenture's Hub Portal for Beneficiary Declarations
                            </span>
                            <span class="login100-form-title p-b-0">
                                Choose Beneficiary Type
                            </span>
                            <Row className="w-100">
                                <Col md={6}>
                                    <a href={this.state.URL + "/Resident"} className="text-white">
                                            <div className="icon_box">
                                                <img src={ResidentUser} width="90" />
                                           
                                            <h3 className="m-t-10">Resident Debenture Holder</h3>
                                        </div>
                                    </a>
                                </Col>
                                <Col md={6}>
                                    <a href={this.state.URL + "/NonResident"} className="text-black">
                                            <div className="icon_box">
                                                <img src={nonResidentUser} width="90" />
                                            {/*<FontAwesomeIcon icon="user-alt" size="5x" color="#c21ee2"   />*/}
                                            <h3 className="m-t-10">Non-Resident Debenture Holder</h3>
                                        </div>
                                    </a>
                                </Col>
                            </Row>
                           
                            <div className="text-center w-full p-t-30">
                                <span className="txt1">
                                    Existing User?
						            </span>

                            <button onClick={this.handleLogin} className="txt_a m-l-10" > Sign In</button>
                            </div>
                            <div className="txt1 text-center p-t-10">
                                    <span> Kindly refer the <a href={process.env.PUBLIC_URL + "/Templates/Easy-Debentures-User-Manual.pdf"} download="Easy-Debentures-User-Manual.pdf" className="txt_a">User Guide</a>. In case of any clarifications, reach out to us at <a href="mailto:debentureshubsupport@nexdigm.com" className="txt_a">debentureshubsupport@nexdigm.com</a></span>
                            </div>
                            <div className="txt1 text-center p-t-30" style={{ textAlign: "center" }}>
                                <span style={{ verticalAlign: "middle" }}>Powered by </span>
                                <img src={NexdmsmImg} style={{ verticalAlign: "middle" }}/>
                            </div>
                        </div>
                        
                        
                    </div>
                    </div>
                    </div>
            </div>
           
      </div>
    );
  }
}
